import { useEffect, useRef } from "react";
import ReactToPrint from "react-to-print";
import PrintInvoice1Single from "./PrintInvoice1Single";

type IProps = {
  reservation: any;
  traveler: any;
  showPrint: (val: boolean) => void;
};

const ComponentToPrintTravelers = ({ reservation, traveler, showPrint }: IProps) => {
  const componentRef = useRef<any>(null);
  const buttonRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    setTimeout(() => {
      buttonRef.current?.click();
    }, 0);
  }, []);

  return (
    <div>
      <ReactToPrint
        trigger={() => (
          <button
            id="print"
            ref={buttonRef}
            style={{ display: "none" }}
          />
        )}
        content={() => componentRef.current}
        onAfterPrint={() => {
          showPrint(false);
        }}
      />

      <div style={{ display: "none" }}>
        <PrintInvoice1Single
          ref={componentRef}
          reservation={reservation}
          traveler={traveler}
        />
      </div>
    </div>
  );
};

export default ComponentToPrintTravelers;
